module.exports = __webpack_public_path__ + "img/stu-no-1.98223433.svg";